import React from 'react';
import './CourseContent.css';

const lessons = [
  {
    title: "How To Set Up Mica In 5 Minutes",
    description: "Get Mica installed and configured in your local Excel environment."
  },
  {
    title: "Why Traditional Excel Learning Is Broken",
    description: "Understand why memorizing formulas doesn't work and what to do instead."
  },
  {
    title: "Use Mica To Learn Excel By Watching It Work",
    description: "See how AI builds formulas step by step as you describe your tasks."
  },
  {
    title: "Replace 80% of Your Daily Excel Tasks",
    description: "Automate repetitive work and focus on analysis, not data entry."
  }
];

function CourseContent() {
  return (
    <section className="course-content section">
      <div className="container">
        <h2 className="section-title">What You'll Learn</h2>
        <div className="lessons-grid">
          {lessons.map((lesson, index) => (
            <div key={index} className="lesson-card">
              <div className="lesson-number">{index + 1}</div>
              <h3>{lesson.title}</h3>
              <p>{lesson.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CourseContent;
